import { createTheme } from '@mui/material';

export const theme = createTheme({
  typography: {
    fontFamily: ['TTCommons', 'sans-serif'].join(','),
    htmlFontSize: 16,

    body: {
      fontSize: '1rem', // 16px
      lineHeight: '19px',
      letterSpacing: '0.02em'
    },
    body1: {
      fontSize: '1.125rem', // 18px
      lineHeight: '24px',
      letterSpacing: '0.02em'
    },
    h1: {
      fontSize: '2rem', // 32px
      lineHeight: '32px',
      letterSpacing: '-0.01em',
      fontWeight: 500
    },
    h2: {
      fontWeight: 500,
      fontSize: '1.625rem', // 26px
      lineHeight: '28px'
    },
    subtitle1: {
      fontSize: '0.75rem', // 12px
      lineHeight: '14px',
      letterSpacing: '0.06em'
    },
    subtitle2: {
      fontSize: '1.25rem', // 20px
      lineHeight: '24px',
      letterSpacing: '0.02em',
      fontWeight: 'normal'
    },
    subtitleForm: {
      fontSize: '1.25rem', // 20px
      lineHeight: '24px',
      letterSpacing: '0.02em',
      fontWeight: 500
    }
  },
  components: {
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& tr': {
            '& th': {
              padding: '16px 8px',

              '& > span': {
                fontSize: '0.875rem',
                lineHeight: '20px',
                letterSpacing: '0.02em',
                color: '#0C0D0D',
                fontWeight: 'normal',

                '& > svg': {
                  opacity: 1,
                  marginLeft: '8px'
                }
              }
            },
            '& th:first-child': {
              padding: '16px 8px 16px 16px'
            },
            '& th:last-child': {
              padding: '16px 16px 16px 8px'
            }
          }
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: '1rem',
          borderColor: '#DDE1E5',
          padding: '16px 8px',
          '&:first-child': {
            padding: '16px 8px 16px 16px'
          },
          '&:last-child': {
            padding: '16px 16px 16px 8px'
          }
        }
      }
    },
    MuiList: {
      styleOverrides: {
        root: {
          padding: 0
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          padding: '8px 12px',
          fontSize: '1.125rem',
          lineHeight: '24px',
          letterSpacing: '0.02em'
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          border: '1px solid #DDE1E5',
          boxShadow: '0px 2px 6px rgba(42, 70, 94, 0.12)',

          '& > ul.MuiAutocomplete-listbox': {
            padding: 0,

            '& > li': {
              padding: '6px 12px'
            }
          }
        }
      }
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          color: '#667A8B'
        }
      }
    },
    MuiBreadcrumbs: {
      styleOverrides: {
        root: {
          fontSize: '1.25rem',
          'ol > li > p': {
            fontSize: '1.25rem'
          }
        }
      }
    },
    MuiLink: {
      variants: [
        {
          props: { variant: 'form' },
          style: {
            cursor: 'pointer',
            textDecoration: 'none',
            borderBottom: '1px solid #DDE1E5',
            fontSize: '1.125rem',
            ':hover': {
              borderBottom: '1px solid #267CCC'
            }
          }
        }
      ]
    }
  },

  palette: {
    primary: {
      main: '#267CCC',
      light: '#F3F9FF'
    },
    secondary: {
      main: '#F3F5F6'
    },
    text: {
      primary: '#151C22',
      secondary: '#667A8B'
    },
    grey: {
      1000: '#8897A5',
      900: '#0C0D0D',
      600: '#F6F6F6'
    },
    warning: {
      main: '#FFBB37'
    },
    success: {
      main: '#90BC34'
    },
    error: {
      main: '#F5463B',
      light: '#fff5f4'
    },
    divider: '#EEF0F2',
    action: {
      default: '#FFFFFF',
      disabled: '#dde1e5',
      disabledBackground: '#EFEFEF'
    }
  }
});
